// HorizontalProgress.jsx
import React, { useLayoutEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

function HorizontalProgress({
  id = "progress-bar",
  value = 75,
  color = "#fcb63c",
  duration = 1000,
}) {
  const chartRef = useRef(null);

  useLayoutEffect(() => {
    const container = document.getElementById(id);
    if (!container) return;

    // cleanup old chart
    if (chartRef.current) {
      chartRef.current.dispose();
      chartRef.current = null;
    }
    while (container.firstChild) container.removeChild(container.firstChild);

    // create chart
    const chart = am4core.create(id, am4charts.XYChart);
    chart.padding(0, 0, 0, 0);
    chart.data = [{ category: "Progress", value }];

    // x axis
    const valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.strictMinMax = true;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.renderer.grid.template.disabled = true;

    // y axis
    const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.labels.template.disabled = true;
    categoryAxis.renderer.grid.template.disabled = true;

    // series
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueX = "value";
    series.dataFields.categoryY = "category";
    series.columns.template.height = 28;
    series.columns.template.strokeWidth = 0;
    series.columns.template.fill = am4core.color(color);
    series.columns.template.cornerRadiusTopRight = 6;
    series.columns.template.cornerRadiusBottomRight = 6;

    // label directly on column
    const label = series.columns.template.createChild(am4core.Label);
    label.text = "{valueX}%";
    label.fontSize = 14;
    label.fill = am4core.color("#000");
    label.horizontalCenter = "left";
    label.dx = 10; // push outside the bar
    label.valign = "middle";

    // animate bar growing
    series.hiddenState.properties.valueX = 0;
    chart.hiddenState.properties.alpha = 0;
    series.defaultState.transitionDuration = duration;
    chart.logo.disabled = true;

    chartRef.current = chart;

    // eslint-disable-next-line consistent-return
    return () => {
      if (chartRef.current) {
        chartRef.current.dispose();
        chartRef.current = null;
      }
    };
  }, [id, value, color, duration]);

  return <div id={id} style={{ width: "80%", height: "56px" }} />;
}

export default HorizontalProgress;
